// extracted by mini-css-extract-plugin
export default {"singleAdHost":"SingleAdHost_singleAdHost__eLZrm"};